import React, { useEffect } from 'react';
import axios from 'axios';
import { useDonation } from '../../context/DonationContext';
import loaderAnimation from '../../assets/lottie/loader_inspira.json';
import Lottie from 'lottie-react';

const CreditCard = () => {
    const { donation } = useDonation();

    useEffect(() => {
        const handlePayment = async () => {

            const payload = {
                amount: donation.amount,
                description: 'Donación con botón OpenPay',
                send_email: "false",
                customer: {
                    name: donation.personalInfo.name,
                    last_name: donation.personalInfo.last_name,
                    phone_number: donation.personalInfo.phone,
                    email: donation.personalInfo.email,
                    nickname: donation.personalInfo.nickname,
                },
            };

            console.log("Payload enviado al backend:", payload);

            try {
                // const response = await axios.post('http://127.0.0.1:8000/api/donations/process/', payload);
                const response = await axios.post('https://admin-django-inspira.azurewebsites.net/api/donations/process/', payload);

                console.log("Respuesta del backend:", response.data);

                const { checkout_link } = response.data;
                window.location.href = checkout_link;
            } catch (error) {
                console.error('Error al generar el botón de pago:', error);
                if (error.response) {
                    console.error('Detalles del error:', error.response.data);
                }
                alert('Hubo un error al procesar el pago.');
            }
        };
        handlePayment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [donation]);

    return (
        <div className='min-h-96 bg-gray-100 flex items-center justify-center p-4 sm:p-1 lg:p-8'>
            <div className='bg-white rounded-lg shadow-xl p-6 sm:p-8 lg:p-10 text-center max-w-md w-full'>
                {/* Text Section */}
                <h2 className='text-2xl sm:text-3xl font-extrabold text-gray-800 mb-6'>
                    Redirigiendo al pago seguro...
                </h2>
                <p className='text-gray-600 text-base sm:text-lg mb-8'>
                    Por favor, no cierres esta ventana. Serás dirigido automáticamente a la pasarela de pago.
                </p>
                <div className='flex justify-center items-center mb-6'>
                    <Lottie
                        animationData={loaderAnimation}
                        loop={true}
                        autoplay={true}
                        className='w-32 h-32 sm:w-40 sm:h-40' // Adjust size for responsiveness
                    />
                </div>
                <p className='text-sm text-gray-500'>
                    Procesando tu solicitud...
                </p>
            </div>
        </div>
    );
};

export default CreditCard;
